export const SERVER_URL = '/api/auth';
export const FORGOT_PASSWORD = `${SERVER_URL}/password-reset`;
export const GET_PROFILE_URL = `${SERVER_URL}/profile`;
export const LOGOUT_URL = `${SERVER_URL}/logout`;
export const MAGIC_LINK_LOGIN = `${SERVER_URL}/magic-link-login`;
export const PUBLIC_KEYS_URL = `${SERVER_URL}/public-keys`;
export const RESET_PASSWORD = `${SERVER_URL}/password-reset-finish`;
export const SEND_MAGIC_LINK_EMAIL = `${SERVER_URL}/send-magic-link-email`;
export const TOKEN_EXCHANGE_URL = `${SERVER_URL}/token-exchange`;
export const TOKEN_EXCHANGE_ONE_TIME_USE_URL = `${SERVER_URL}/external/lookup-token-exchange`;
export const TOKEN_REFRESH_URL = `${SERVER_URL}/token-refresh`;
export const VALIDATE_TOKEN_URL = `${SERVER_URL}/validate`;
export const MF_ACCESS_TOKEN = 'mf_access_token';
//# sourceMappingURL=strings.js.map